import type { PresentationalFilterFacet } from '../types';

export default function getFilterPathParameters(filters: PresentationalFilterFacet[]) {
  const mapFilterToPathParameter = (filter: PresentationalFilterFacet) =>
    `${filter.name}:${filter.values.filter(String).join(',')}`;

  const updatedFilterPathParameters = filters
    .map(mapFilterToPathParameter)
    .join('/')
    .replace(/\/$/, '');

  return updatedFilterPathParameters;
}
